export default "__VITE_ASSET__CZ1eq0eH__"